<template>
  <!-- <div class="position-relative"> -->
  <v-container
    fluid
    class="position-relative"
    style="backdrop-filter: blur(2px); z-index: 1"
  >
    <v-responsive :style="dynamicStyles" class="position-relative">
      <!-- Partículas como fondo -->
      <!-- Contenido principal -->
      <v-row
        class="h-100 px-4 px-md-8 px-lg-10"
        align-lg="center"
        align-md="center"
      >
        <v-col cols="12" md="6" class="px-lg-8 px-xl-16">
          <div class="text-center">
            <!-- <v-chip
                class="pa-3 text-h5 hidden-sm-and-down"
                border="thin opacity-25"
                color="surface"
                variant="flat"
              >
                Tu Apoyo VIP
              </v-chip> -->
            <h1
              class="text-h4 text-md-h4 text-lg-h3 text-xl-h2 font-weight-bold mb-6"
            >
              Eleva tu Negocio
              <!-- <br class="d-md-none" />
                <Typewriter :words="['Potencial', 'Crecimiento', 'Éxito']" /> -->
              <br />
            </h1>
            <h2>
              Truster Cloud te da la información para decidir y el poder para
              escalar.
            </h2>
            <v-card-title class="text-h6 text-lg-h5 text-xl-h4 mb-10">
              Automatiza ventas, logística y administración, dándote el control
              total y la información que necesitas para tomar decisiones y
              escalar tu negocio de manera inteligente.
            </v-card-title>
            <v-card-actions class="justify-center py-0">
              <v-btn
                color="primary"
                density="default"
                rounded="pill"
                variant="elevated"
                :size="smAndDown ? 'small' : 'large'"
                href="/contacto"
                >Comenzar</v-btn
              >
              <!-- <v-btn
                color="primary"
                density="default"
                rounded="pill"
                variant="outlined"
                :size="smAndDown ? 'small' : 'large'"
                >Más información</v-btn
              > -->
            </v-card-actions>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pb-16">
          <!-- <div > -->
          <!-- <v-responsive min-width="100%" max-width="1000px"> -->
          <div class="position-relative">
            <NuxtImg
              densities="x1"
              class="w-100 ml-md-auto elevation-10 rounded-xl"
              src="/assets/home/faqs1.webp"
              alt="Hero de Truster Cloud"
              preload
              sizes="95vw sm:800px lg:800px xl:1000px"
              style="aspect-ratio: 1.8"
            >
              <!-- <template #default="{ src, imgAttrs, isLoaded }">
              {{ imgAttrs }}
                  <v-img
                  v-bind="imgAttrs"
                  width="600"
                  :loading="isLoaded"
                  :aspect-ratio="1.6"
                    :src="src"
                  />
                </template> -->
            </NuxtImg>

            <NuxtImg
              sizes="150px md:300px lg:300px"
              class="w-auto position-absolute elevation-10 rounded-xl bouncing-img"
              :style="{ left: mdAndDown ? '10px' : '0', bottom: '-32px' }"
              src="/assets/home/faqs2.webp"
              alt="Imagen flotante de Hero de Truster Cloud"
              preload
            />
            <!-- </v-responsive> -->
          </div>
          <!-- </div> -->
        </v-col>
      </v-row>
    </v-responsive>
    <Transition name="fade" mode="out-in">
      <NuxtParticles
        v-if="showParticles"
        id="tsparticles"
        :key="particlesKey"
        ref="particlesRef"
        :options="options"
        class="particles-bg position-absolute"
        @load="onLoad"
      />
    </Transition>
  </v-container>
  <!-- </div> -->
</template>

<script setup lang="ts">
// 1. Importaciones
import { useLayout, useTheme } from "vuetify";
import type { Container } from "@tsparticles/engine";
import { computed, ref, watch, nextTick } from "vue";
import { useDisplay } from "vuetify";
// 2. Composables y referencias reactivas
const { getLayoutItem } = useLayout();
const { smAndDown, mdAndDown } = useDisplay();
const theme = useTheme();
const particlesKey = ref(0); // Key to force re-render
const showParticles = ref(true); // Controls visibility for transition

// 3. Computed: estilos dinámicos
const appBarHeight = computed(() => getLayoutItem("app-bar")?.size ?? 0);
const dynamicStyles = computed(() => ({
  // Estilos dinámicos basados en la altura del app bar
  // paddingTop: `${appBarHeight.value}px`,
  // paddingBottom: `${appBarHeight.value * 2}px`,
  // height: `calc(100vh - ${appBarHeight.value}px)`,
  // maxHeight: "auto",
}));

// 4. Computed: opciones de partículas
const options = computed(() => {
  // Opciones de configuración para NuxtParticles según el tema actual
  return {
    fullScreen: {
      enable: false,
      zIndex: 0,
    },
    // background: {
    // 	color: {
    // 		value: theme.current.value.colors.background
    // 	}
    // },
    particles: {
      color: {
        value: theme.current.value.colors.primary + "10", // Adding opacity for better visibility
      },
      links: {
        color: theme.current.value.colors.secondary + "10",
        enable: true,
      },
      move: {
        // direction: "none",
        enable: true,
        outMode: "bounce",
        random: false,
        speed: 1,
        straight: false,
      },
      number: {
        value: smAndDown ? 30 : 100,
      },
    },
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "attract",
          distance: 10,
        },
      },
    },
  };
});

// 5. Watchers: reacción a cambios de tema
watch(
  () => theme.name.value,
  async () => {
    // console.log(`[Hero.vue] Theme changed to: ${theme.name.value}. Starting transition.`);
    showParticles.value = false;
    await nextTick(); // Wait for DOM to update (particles hidden)

    particlesKey.value++; // Increment key to force re-render of new instance

    // It might be good to wait for the new instance to potentially load before showing it
    // but NuxtParticles onLoad might handle the visual appearance.
    await nextTick(); // Ensure key change is processed and new component instance is ready
    showParticles.value = true;
    // console.log('[Hero.vue] Particles should now be visible with new theme.');
  }
);

// 6. Métodos y callbacks
const onLoad = (container: Container) => {
  // The container is re-initialized on each key change.
  // console.log('[Hero.vue] Particles loaded, new container instance:', container);
  // Directly play, let the transition handle the visual appearance.
  // The NuxtParticles component should manage its internal loading.
  container.play();
};
</script>

<style scoped>
.bouncing-img {
  animation: bounce 4s ease-in-out infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10%);
  }
}
.particles-bg {
  position: absolute;
  top: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
}

/* Transition styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease; /* Adjust timing to your preference */
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
